import { AnalyticsType } from '@invideoio/web-shared/types/Analytics';
import { Analytics } from '@invideoio/web-shared/utils/analytics';
import { AnalyticsUtils } from '@invideoio/web-shared/utils/analytics/AnalyticsUtils';
import { sanitizeParams } from '@invideoio/web-shared/utils/auth/check-params';
import { BlogSearchAnalytics, ClickCtaAnalytics } from 'src/types/analytics';
import UAParser from 'ua-parser-js';

export enum AmplitudeEvents {
  appLoad = 'App Load',
  clickSignUp = 'Click Signup',
  clickLogin = 'Click Login',
  clickResetPassword = 'Click Reset Password', // pragma: allowlist secret
  clickSupport = 'Click Support',
  experimentViewed = 'Experiment Viewed',
}

export const sendAmplitudeAnalyticEvent = (
  eventName: string,
  eventData: any = {},
  userData: any = {},
) => {
  Analytics.send(AnalyticsType.AMPLITUDE, {
    eventName,
    eventProperties: {
      Pagetype: AnalyticsUtils.getPage(),
      Pagesource: sanitizeParams(),
      ...eventData,
    },
    userProperties: {
      ...userData,
    },
  });
};

export const sendRudderStackAnalyticEvent = (
  data: ClickCtaAnalytics | BlogSearchAnalytics,
) => {
  const eventName = data.event_name;
  const eventProperties = data.event_properties;
  const userProperties = data.user_properties;
  Analytics.send(AnalyticsType.RUDDER_STACK, {
    eventName,
    eventProperties: {
      ...AnalyticsUtils.commonRudderStackEventProperties(),
      ...AnalyticsUtils.toLowerCaseObject((eventProperties as any) ?? {}),
    },
    userProperties: {
      ...AnalyticsUtils.toLowerCaseObject(userProperties ?? {}),
    },
  });
};

export const sendRudderStackIdentifyAnalytic = () => {
  Analytics.identify(AnalyticsType.RUDDER_STACK);
};
